import {Component, OnInit} from '@angular/core';
import {mailPassForm} from '../../../Assets/angular/assets/data/forms/add_email_pass_form';
import {Router} from '@angular/router';

@Component({
    selector: 'app-enter-mail-pass',
    templateUrl: './enter-mail-pass.component.html',
    styleUrls: ['./enter-mail-pass.component.scss']
})
export class EnterMailPassComponent implements OnInit {

    mailPassForm: Array<object>;
    modalId: string;
    textMessage: string;

    constructor(private router: Router) {
        this.mailPassForm = mailPassForm;
        this.modalId = 'confirm-email-pass-modal';
        this.textMessage = 'Tus datos se han guardado correctamente. Ya puedes acceder al área de clientes.';
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('sequence_activate_access')) {
            this.router.navigateByUrl('/activar-acceso');
        }
    }

    navigateToHome() {
        this.router.navigateByUrl('');
    }

}
